package com.gsb.vyapar.bhagya.presentation.navigation.event

import com.gsb.vyapar.bhagya.presentation.Screens

sealed class NavigationUiEvents {
    data class PushView(val screen: Screens) : NavigationUiEvents()
    data object PopView : NavigationUiEvents()
}